import { assign, createMachine, Interpreter } from 'xstate-v4'

export interface Context {
  form: {
    selected: string
    freeText: string
  }
  answer: string
  error: string
}

export function returnHowDidYouHearAboutUsMachine() {
  return createMachine<Context>(
    {
      id: 'howDidYouHearAboutUs',
      initial: 'form',
      context: {
        form: {
          selected: '',
          freeText: '',
        },
        answer: '',
        error: '',
      },
      states: {
        form: {
          type: 'parallel',
          states: {
            validation: {
              initial: 'valid',
              states: {
                valid: {},
                invalid: {},
              },
            },
            showingForm: {
              initial: 'idle',
              states: {
                idle: {},
                normal: {},
              },
            },
          },
          on: {
            UPDATE_ANSWER: {
              actions: ['updateAnswer', 'clearFormErrors'],
              target: 'form.validation.valid',
            },
            UPDATE_FREE_TEXT: { actions: 'updateFreeText' },
            SUBMIT: [
              {
                cond: 'hasNoAnswerSelected',
                target: 'form.validation.invalid',
                actions: assign({
                  error: (_) => 'answerNotSelected',
                }),
              },
              {
                actions: 'setAnswer',
                target: 'submitting',
              },
            ],
          },
        },
        submitting: {
          invoke: {
            src: 'submitAnswer',
            onDone: 'submitted',
            onError: 'form.validation.invalid',
          },
        },
        submitted: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        updateAnswer: assign({
          form: ({ form }, event) => ({
            ...form,
            selected: (event as unknown as { selected: string }).selected,
          }),
        }),
        updateFreeText: assign({
          form: ({ form }, event) => ({
            ...form,
            freeText: (event as unknown as { freeText: string }).freeText,
          }),
        }),
        clearFormErrors: assign({
          error: (_) => '',
        }),
        setAnswer: assign({
          answer: ({ form }) => {
            if (form.selected === 'Somewhere else' && form.freeText !== '') {
              return form.freeText
            }
            return form.selected
          },
        }),
      },
      guards: {
        hasNoAnswerSelected: ({ form }) => form.selected === '',
      },
    },
  )
}

export type HowDidYouHearAboutUsMachineInterpreter = Interpreter<Context>
